function getWidgetHeaderInnerHTML(node) {
    if (!node) return null

    const widgetNode = node.querySelector('[data-element="header"]')
    return widgetNode ? widgetNode.innerHTML : null
}

function getWidgetContentInnerHTML(node) {
    if (!node) return null

    const widgetNode = node.querySelector('[data-element="content"]')
    return widgetNode ? widgetNode.innerHTML : null
}

const configAggregator = (node) => {
    return {
        header: getWidgetHeaderInnerHTML(node),
        content: getWidgetContentInnerHTML(node),
        name: node.getAttribute('data-w-name'),
        city: node.getAttribute('data-w-sign')
    }
}

export default configAggregator
